// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

import { TextField } from '../../../../../atoms';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

type Props = {
  rootStyle?: {},
  fieldName: string,
};

export function FieldStreetComplement({ rootStyle, fieldName }: Props): Node {
  const inputId = useUniqueId();
  const [value, handleChange] = useUserInputAsTextField(fieldName);
  const submitting = useSubmitting();
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  const isOptionalFieldByStreetNumber = useCurrentPaymentTypeOptionalFields('street_number');
  const isOptionalFieldByAddress = useCurrentPaymentTypeOptionalFields('address');

  if (isOptionalFieldByAddress || isOptionalFieldByStreetNumber) {
    return null;
  }

  return (
    <div style={rootStyle} data-test-name="address-street-complement">
      <label htmlFor={inputId}>
        {getFieldLabelByCountry(country)}
      </label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        placeholder="Opcional"
        readOnly={submitting}
        name="address-street-complement"
      />

    </div>
  );
}

function getFieldLabelByCountry(country: string): string {
  switch (country) {
    case 'co':
    case 'pe':
    case 'cl':
    case 'uy':
    case 'cr':
    case 'py':
    case 'pa':
    case 'gt':
    case 'sv':
    case 'do':
      return 'Información Adicional';
    case 'za':
      return 'Additional Information';

    default:
      throw new Error(`Field City: Label not mapped for country ${country}`);
  }
}
